import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapComponent } from './map/map.component';
import { ReportMalfunctionComponent } from './report-malfunction/report-malfunction.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';

const routes: Routes = [
  // { path: '', component: MapComponent },
  { path: 'meld-storing/:id', component: ReportMalfunctionComponent },
  { path: 'hoe-werkt-het', component: HowItWorksComponent },
  { path: 'hoe-werkt-het/:type', component: HowItWorksComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
exports: [RouterModule]
})
export class AppRoutingModule { }
